import { Playback3DScreen as Playback3D } from '@screens';

import { LINKS } from '../utils/routes';

export const Playback3DScreen = () => {
    return <Playback3D getFullActivityLink={LINKS.getFullActivity} />;
};
